import styles from '@styles/components/General/UserCard.module.css';
import Image from './Image';

const UserCard: React.FC<{name: string, imageUrl: string}> = ({name, imageUrl}) => {
    const processName = (name: string) => {
        const words = name.split(' ');
        const processedWords = words.map(word => {
            const firstLetter = word.charAt(0).toUpperCase();
            const restOfWord = word.slice(1).toLowerCase();
            return firstLetter + restOfWord;
        });
        return processedWords.join(' ');        
    }

    return (
        <div className={styles['user-card']}>
            <div className={styles['circle-mask']}>
                <Image src={imageUrl || '/assets/Q.png'} alt="Profile Picture" isRound={true} style={{width: '100%', height: '100%'}} />
            </div>
            <div className={styles['user-name']}>
                {processName(name)}
            </div>
        </div>
    );
};

export default UserCard;
